/* ==========================================================================
   Fashiongirl seasonal badge

   The campaign label is chosen server-side from the date and the product, and
   does not depend on the variant. What does depend on the variant is whether
   there is a discount at all and how big it is, so on every variantChange this
   shows or hides the badges and recomputes the percentage from the variant's
   own prices. The percentage rounds down so a saving is never overstated.
   ========================================================================== */
(function () {
  function update(badge, variant) {
    var onSale = variant && variant.compare_at_price > variant.price;
    badge.hidden = !onSale;
    if (!onSale) return;

    var percent = badge.querySelector('[data-fg-season-percent]');
    if (!percent) return;

    var pct = Math.floor(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
    if (pct < 1) {
      percent.hidden = true;
      return;
    }
    percent.textContent = (percent.getAttribute('data-format') || '−[n] %').replace('[n]', pct);
    percent.hidden = false;
  }

  function bind(root) {
    root.querySelectorAll('[data-fg-season]').forEach(function (badge) {
      if (badge.fgSeasonBound) return;
      var container = badge.closest('[data-section-type="product"]');
      if (!container) return;
      badge.fgSeasonBound = true;
      container.addEventListener('variantChange', function (evt) {
        update(badge, evt.detail && evt.detail.variant);
      });
    });
  }

  bind(document);

  // Quick-shop modals and other product blocks are injected after load.
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) bind(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
